import React, { useState, useEffect } from 'react';
import { DashboardLayout } from '../components/layout/DashboardSidebar';
import api from '../services/api';

const PurchaseHistoryPage = () => {
  const [orders, setOrders]     = useState([]);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [tab, setTab]           = useState('payments');

  useEffect(() => {
    api.get('/users/purchase-history')
      .then(res => {
        if (res.data.success) {
          setOrders(res.data.data.orders || []);
          setPayments(res.data.data.payments || []);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
  };

  const formatAmount = (v) => v ? `₹${parseFloat(v).toLocaleString('en-IN')}` : '—';

  const activeData = tab === 'payments' ? payments : orders;

  return (
    <DashboardLayout title="Purchase History">
      <div className="p-6 md:p-8 max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Purchase History</h1>
        <p className="text-text-muted mb-8">All your orders and payment transactions.</p>

        {/* Tabs */}
        <div className="flex bg-white/10 rounded-lg p-1 w-fit mb-6">
          {[
            { key: 'payments', label: `💳 Payments (${payments.length})` },
            { key: 'orders',   label: `📦 Orders (${orders.length})` },
          ].map(t => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`px-5 py-2 rounded-md text-sm font-medium transition-all ${
                tab === t.key ? 'bg-accent-gold text-black shadow-lg' : 'text-text-muted hover:text-white'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-20 text-text-muted animate-pulse">Loading history...</div>
        ) : activeData.length === 0 ? (
          <div className="text-center py-20 bg-white/5 rounded-2xl border border-white/10">
            <div className="text-5xl mb-4">📭</div>
            <p className="text-text-muted">No {tab} found.</p>
          </div>
        ) : tab === 'payments' ? (
          <div className="space-y-4">
            {payments.map((p, i) => (
              <div key={p.Id || i} className="bg-white/5 rounded-2xl border border-white/10 p-5 flex flex-col sm:flex-row sm:items-center gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`w-2 h-2 rounded-full ${p.Status === 'captured' ? 'bg-green-500' : 'bg-yellow-500'}`} />
                    <h3 className="font-bold text-text-light truncate">{p.SubscriptionName || 'Subscription'}</h3>
                  </div>
                  <p className="text-text-muted text-sm truncate">{p.PackTitle || ''}</p>
                  <p className="text-text-muted text-xs mt-1">{p.CourseName || ''}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <div className="text-xl font-bold text-accent-gold">{formatAmount(p.Amount)}</div>
                  <div className="text-xs text-text-muted">{formatDate(p.PurchaseDate)}</div>
                  {p.ExpireOn && (
                    <div className="text-xs text-text-muted">Expires: {formatDate(p.ExpireOn)}</div>
                  )}
                </div>
                <div className="flex-shrink-0 text-right">
                  <span className={`px-2 py-1 rounded text-xs font-semibold ${p.Status === 'captured' ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                    {p.Status || 'pending'}
                  </span>
                  {p.razorpay_payment_id && (
                    <p className="text-xs text-text-muted font-mono mt-1 truncate max-w-[160px]">{p.razorpay_payment_id}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="overflow-x-auto bg-white/5 rounded-2xl border border-white/10">
            <table className="w-full text-left text-sm">
              <thead className="bg-white/10 text-accent-gold">
                <tr>
                  <th className="p-4">Order No</th>
                  <th className="p-4">Date</th>
                  <th className="p-4">Pack</th>
                  <th className="p-4">Course</th>
                  <th className="p-4">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10">
                {orders.map((o, i) => (
                  <tr key={o.OrderId || i} className="hover:bg-white/5">
                    <td className="p-4 font-mono text-xs">{o.OrderNo || `#${o.OrderId}`}</td>
                    <td className="p-4">{formatDate(o.OrderDate)}</td>
                    <td className="p-4">{o.SubscriptionName || o.PackTitle || '—'}</td>
                    <td className="p-4">{o.CourseName || '—'}</td>
                    <td className="p-4">
                      <span className={`px-2 py-1 rounded text-xs font-semibold ${o.OrderStatus === 1 ? 'bg-green-500/20 text-green-400' : 'bg-gray-500/20 text-gray-400'}`}>
                        {o.OrderStatus === 1 ? 'Completed' : 'Pending'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default PurchaseHistoryPage;
